import * as React from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "7 10 10 5", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 10l5 5 5-5z" }));
export default SvgTriangle;
